export class Eleve {
    nom = '';
    prenom = '';
    id_classe = 0;
    classe: string | {id_classe: string, nom_classe: string, url_classe: string} = '';
    code_postal: number;
    ville = '';
    etablissement = '';
    matieres: any[] = [];
    centre: number;

    constructor(options?: any) {
        if (options) {
            this.nom = options.nom;
            this.prenom = options.prenom;
            this.id_classe = options.id_classe;
            this.code_postal = options.code_postal;
            this.ville = options.ville;
            this.etablissement = options.etablissement;
            this.matieres = options.matieres;
            this.centre = options.centre;
        }
    }
}

export class Client {
    nom = '';
    prenom = '';
    mail = '';
    telephone = '';
    adresse = '';
    complement_adresse = '';
    code_postal: number;
    ville = '';

    constructor(options?: any) {
        if (options) {
            this.nom = options.nom;
            this.prenom = options.prenom;
            this.mail = options.mail;
            this.telephone = options.telephone;
            this.adresse = options.adresse;
            this.code_postal = options.code_postal;
            this.ville = options.ville;
        }
    }
}

export class CandidatureForm {
    id_instance: number;
    id_offre_emploi: number;
    type_formation: string;
    cours_presentiels_uniquement: boolean;
    recherche_entreprise: boolean;
    choix_speficiques: any;
    nom: string;
    prenom: string;
    email: string;
    telephone: string;
    birthday: Date;
    annee_bac: string;
    cv: string;
    observation: string;

    constructor(options?: any) {
        if (options) {
            this.id_instance = options.id_instance;
            this.id_offre_emploi = options.id_offre_emploi;
            this.type_formation = options.type_formation;
            this.cours_presentiels_uniquement = options.cours_presentiels_uniquement;
            this.recherche_entreprise = options.recherche_entreprise;
            this.choix_speficiques = options.choix_speficiques;
            this.nom = options.nom;
            this.prenom = options.prenom;
            this.email = options.email;
            this.telephone = options.telephone;
            this.birthday = options.birthday;
            this.cv = options.cv;
            this.observation = options.observation;
        }
    }
}

export class StageForm {
    eleve1: Eleve;
    parent: Client;
    id_instance: number;

    constructor(options?: any) {
        if (options) {
            this.eleve1 = options.eleve1;
            this.parent = options.parent;
            this.id_instance = options.id_instance;
        }
    }
}

export class Prof {
    id_prof: number;
    nom: string;
    prenom: string;
    profil: string;
    enseignement: string;
    photo: string;

    constructor(options?: any) {
        if (options) {
            this.id_prof = options.id_prof;
            this.nom = options.nom;
            this.prenom = options.prenom;
            this.profil = options.profil;
            this.enseignement = options.enseignement;
            this.photo = options.photo;
        }
    }
}
